<nz-spin [nzSpinning]="loading" [nzSize]="'large'" [nzTip]="verbiage" style="min-height: 200px; padding: 10px;">
  <div class="payroll-container">
    <div class="page-hero section-card">
      <nz-page-header class="page-header" nzTitle="Pay History"
        nzSubtitle="Track payouts, adjustments, and performance."></nz-page-header>
    </div>

    <div class="payroll-content">
      <div class="card-container">
        <nz-row nzGutter="16" class="summary-grid">
          <nz-col [nzXs]="24" [nzSm]="12" [nzXl]="6">
            <nz-card nzHoverable class="kpi-card section-card">
              <nz-statistic [nzTitle]="'Lifetime Net'" [nzValue]="(lifetimeNet | number: '1.0-2')!" [nzPrecision]="2"
                nzPrefix="$"></nz-statistic>
            </nz-card>
          </nz-col>
          <nz-col [nzXs]="24" [nzSm]="12" [nzXl]="6">
            <nz-card nzHoverable class="kpi-card section-card">
              <nz-statistic [nzTitle]="'YTD Net'" [nzValue]="(ytdNet | number: '1.0-2')!" [nzPrecision]="2"
                nzPrefix="$"></nz-statistic>
            </nz-card>
          </nz-col>
          <nz-col [nzXs]="24" [nzSm]="12" [nzXl]="6">
            <nz-card nzHoverable class="kpi-card section-card">
              <nz-statistic [nzTitle]="'3-Period Avg'" [nzValue]="(threePeriodAvg | number: '1.0-2')!" [nzPrecision]="2"
                nzPrefix="$"></nz-statistic>
            </nz-card>
          </nz-col>
          <nz-col [nzXs]="24" [nzSm]="12" [nzXl]="6">
            <nz-card nzHoverable class="kpi-card section-card">
              <nz-statistic [nzTitle]="'Closed Orders'" [nzValue]="(salesCountTotal | number)!"></nz-statistic>
            </nz-card>
          </nz-col>
        </nz-row>

        <div nzHoverable class="actual-cards">
          <nz-row nzGutter="16" class="widgets-grid">
            <nz-col [nzXs]="24" [nzLg]="12" [nzXl]="10" class="small-margin">
              <nz-card nzHoverable class="widget section-card kpi-card" nzTitle="Wage Trend" nzBordered="false">
                <div class="chart-wrap">
                  <canvas baseChart [data]="trendChartData" [options]="trendChartOptions" chartType="line"></canvas>
                </div>
              </nz-card>
            </nz-col>
            <nz-col [nzXs]="24" [nzLg]="12" [nzXl]="6" class="small-margin">
              <nz-card nzHoverable class="widget section-card kpi-card" nzTitle="Breakdown" nzBordered="false">
                <div class="chart-wrap">
                  <canvas baseChart [data]="donutChartData" [options]="donutChartOptions" chartType="doughnut"></canvas>
                </div>
              </nz-card>
            </nz-col>
            <nz-col [nzXs]="24" [nzLg]="12" [nzXl]="8" class="small-margin">
              <nz-card nzHoverable class="widget highlight section-card kpi-card" nzBordered="false">
                <div class="widget-heading">
                  <nz-badge nzStatus="success" nzText="Latest payout"></nz-badge>
                  <div class="muted" *ngIf="latestPayoutDate">{{ formatPayDate(latestPayoutDate) }}</div>
                </div>
                <div class="payout-amount">{{ latestPayoutAmount | currency }}</div>
                <nz-divider></nz-divider>
                <nz-descriptions nzSize="small" [nzColumn]="1" nzBordered>
                  <nz-descriptions-item nzTitle="Net">{{ latestPayoutAmount | currency }}</nz-descriptions-item>
                  <nz-descriptions-item nzTitle="Commission">{{ latestCommissionAmount | currency
                    }}</nz-descriptions-item>
                  <nz-descriptions-item nzTitle="Adjustments">{{ latestAdjustmentAmount | currency
                    }}</nz-descriptions-item>
                  <nz-descriptions-item nzTitle="Holdbacks" *ngIf="latestHoldbackAmount !== 0">{{ latestHoldbackAmount |
                    currency }}</nz-descriptions-item>
                </nz-descriptions>
              </nz-card>
            </nz-col>
            <nz-col [nzXs]="24" [nzLg]="12" [nzXl]="10" class="small-margin">
              <nz-card nzHoverable class="widget section-card kpi-card" nzTitle="Adjustments" nzBordered="false">
                <div class="chart-wrap">
                  <canvas baseChart [data]="upcomingChartData" [options]="upcomingChartOptions"
                    chartType="bar"></canvas>
                </div>
              </nz-card>
            </nz-col>
          </nz-row>
        </div>
      </div>

      <div *ngIf="motivationalMessage" class="motivation">
        <nz-alert nzType="success" [nzMessage]="motivationalMessage" nzShowIcon></nz-alert>
      </div>

      <div class="filters-card section-card">
        <nz-space class="filters" nzWrap nzAlign="center">
          <nz-space-item *ngIf="associations?.length">
            <nz-select nzShowSearch nzAllowClear [ngModel]="selectedUserId" (ngModelChange)="onUserChange($event)"
              nzPlaceHolder="View pay for...">
              <nz-option *ngFor="let assoc of associations" [nzValue]="assoc.id"
                [nzLabel]="(assoc.name | titlecase)"></nz-option>
            </nz-select>
          </nz-space-item>
          <nz-space-item>
            <nz-range-picker [(ngModel)]="dateRange" (ngModelChange)="onDateRangeChange($event)"></nz-range-picker>
          </nz-space-item>
          <nz-space-item class="filters-search">
            <nz-input-group nzPrefixIcon="search">
              <input nz-input placeholder="Search customer, rule, amount" [(ngModel)]="searchText"
                (ngModelChange)="onSearchTextChange()" />
            </nz-input-group>
          </nz-space-item>
          <nz-space-item>
            <button nz-button nzType="primary" (click)="exportToCSV()" [disabled]="!selectedCycleId">Export CSV</button>
          </nz-space-item>
        </nz-space>
      </div>

      <!-- Need batching for this guy -->
      <nz-card nzTitle="Payroll Cycles" class="desktop-table section-card table-card mobile-cards" nzBordered="false">
        <div class="table-wrap">
          <nz-table [nzData]="groupedPayHistory" nzBordered [nzShowPagination]="false" [nzScroll]="{ x: '960px' }">
            <thead>
              <tr>
                <!-- <th></th> -->
                <th>Pay Date</th>
                <!-- <th>Period</th> -->
                <th>Total Commissions</th>
                <th>Total Overrides</th>
                <th>Holdbacks</th>
                <!-- <th>Adjustments</th> -->
                <th>Net Pay</th>
                <th>Total Sales</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let cycle of groupedPayHistory; trackBy: trackByCycleId">
                <td>
                  <button nz-button nz-popover nzPopoverContent="View details" nzType="primary" nzShape="circle"
                    (click)="loadCycleCustomers(cycle.id)">
                    <span nz-icon nzType="eye" nzTheme="outline"></span>
                  </button>
                </td>
                <td>{{ formatPayDate(cycle.payDate) }}</td>
                <!-- <td>
                  <ng-container *ngIf="cycle.startDate && cycle.endDate; else fallbackPeriod">
                    Through {{ cycle.endDate | date:'MMM d' }}
                  </ng-container>
                  <ng-template #fallbackPeriod>
                    <ng-container *ngIf="cycle.cycles?.length; else noPeriod">
                      Through {{ cycle.cycles[0]?.endDate | date:'MMM d' }}
                    </ng-container>
                    <ng-template #noPeriod>
                      N/A
                    </ng-template>
                  </ng-template>
                </td> -->
                <td>{{ cycle.totalCommissions | currency }}</td>
                <td>{{ cycle.totalOverrides | currency }}</td>
                <td>{{ cycle.totalHoldbacks | currency }}</td>
                <!-- <td>{{ cycle.totalAdjustments | currency }}</td> -->
                <td><strong>{{ cycle.netPay | currency }}</strong></td>
                <td>{{ cycle.totalSales }}</td>
                <td>
                  <nz-tag [nzColor]="getStatusColor(cycle.status || 'paid')">
                    {{ (cycle.status || 'paid') | titlecase }}
                  </nz-tag>
                </td>
              </tr>
            </tbody>
          </nz-table>
        </div>
      </nz-card>

      <div *ngIf="totalCycleCount" class="table-pagination-note">
        <span>Loaded {{ allGroupedPayHistory.length }} of {{ totalCycleCount }} cycles</span>
        <button nz-button nzType="default" class="load-more-btn" *ngIf="hasMoreCycles" (click)="loadMoreCycles()"
          [disabled]="loadingMoreCycles">
          <span nz-icon [nzType]="loadingMoreCycles ? 'loading' : 'plus'"></span>
          {{ loadingMoreCycles ? 'Loading' : 'Show more cycles' }}
        </button>
      </div>

      <div class="mobile-cards section-card" *ngIf="groupedPayHistory?.length">
        <h3 class="mobile-section-title">Payroll Cycles</h3>
        <ng-container *ngFor="let cycle of groupedPayHistory; trackBy: trackByCycleId">
          <nz-card class="cycle-card" nzBordered="false">
            <div class="card-header" (click)="toggleCycleCardExpansion(cycle.id)">
              <div class="card-header-left">
                <div class="card-date">{{ formatPayDate(cycle.payDate, 'MMM d, yyyy') }}</div>
                <div class="card-period">
                  <ng-container *ngIf="cycle.startDate && cycle.endDate; else mobileFallbackPeriod">
                    {{ cycle.startDate | date:'MMM d' }} - {{ cycle.endDate | date:'MMM d' }}
                  </ng-container>
                  <ng-template #mobileFallbackPeriod>
                    <ng-container *ngIf="cycle.cycles?.length; else mobileNoPeriod">
                      {{ cycle.cycles[0]?.startDate | date:'MMM d' }} - {{ cycle.cycles[0]?.endDate | date:'MMM d' }}
                    </ng-container>
                    <ng-template #mobileNoPeriod>N/A</ng-template>
                  </ng-template>
                </div>
              </div>
              <div class="card-header-right">
                <div class="card-amount">{{ cycle.netPay | currency }}</div>
                <div class="card-header-actions">
                  <nz-tag [nzColor]="getStatusColor(cycle.status || 'paid')" class="card-status">
                    {{ (cycle.status || 'paid') | titlecase }}
                  </nz-tag>
                  <i nz-icon [nzType]="isCycleCardExpanded(cycle.id) ? 'up' : 'down'" class="expand-icon"></i>
                </div>
              </div>
            </div>
            <div class="card-details" *ngIf="isCycleCardExpanded(cycle.id)">
              <nz-descriptions nzSize="small" [nzColumn]="1">
                <nz-descriptions-item nzTitle="Total Commissions">{{ cycle.totalCommissions | currency
                  }}</nz-descriptions-item>
                <nz-descriptions-item nzTitle="Holdbacks">{{ cycle.totalHoldbacks | currency }}</nz-descriptions-item>
                <nz-descriptions-item nzTitle="Adjustments">{{ cycle.totalAdjustments | currency
                  }}</nz-descriptions-item>
                <nz-descriptions-item nzTitle="Net Pay">
                  <strong>{{ cycle.netPay | currency }}</strong>
                </nz-descriptions-item>
                <nz-descriptions-item nzTitle="Total Sales">{{ cycle.totalSales }}</nz-descriptions-item>
              </nz-descriptions>
              <button nz-button nzType="default" nzBlock class="view-customers-btn"
                (click)="loadCycleCustomers(cycle.id); $event.stopPropagation();"
                [nzLoading]="customerDetailsLoading && selectedCycleId === cycle.id">
                <span nz-icon [nzType]="isCycleExpanded(cycle.id) ? 'up' : 'down'"></span>
                {{ isCycleExpanded(cycle.id) ? 'Hide' : 'View' }} Customer Details
              </button>
            </div>
          </nz-card>
        </ng-container>
        <div class="mobile-pagination" *ngIf="totalCycleCount">
          <span class="pagination-text">
            Loaded {{ allGroupedPayHistory.length }} of {{ totalCycleCount }} cycles
          </span>
          <button nz-button nzBlock nzType="default" *ngIf="hasMoreCycles" [disabled]="loadingMoreCycles"
            (click)="loadMoreCycles()">
            <span nz-icon [nzType]="loadingMoreCycles ? 'loading' : 'plus'"></span>
            {{ loadingMoreCycles ? 'Loading more...' : 'Show more cycles' }}
          </button>
        </div>
      </div>

      <nz-card nzTitle="Customer Performance" *ngIf="selectedCycleCustomers?.length"
        class="desktop-table section-card table-card" nzBordered="false">
        <nz-table [nzData]="selectedCycleCustomers" [nzLoading]="customerDetailsLoading" nzBordered nzShowSizeChanger
          nzShowPagination="true" [nzPageSize]="15" [nzScroll]="{ x: '960px' }">
          <thead>
            <tr>
              <th></th>
              <th>Customer</th>
              <th>Lead Type</th>
              <th>Product</th>
              <th>Plan</th>
              <th>Activation Date</th>
              <th>Net Pay</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let customer of selectedCycleCustomers">
              <td>
                <button nz-button nz-popover nzPopoverContent="View details" nzType="primary" nzShape="circle"
                  (click)="viewCustomerPerformanceDeets(customer)">
                  <span nz-icon nzType="eye" nzTheme="outline"></span>
                </button>
              </td>
              <td>{{ customer.customerName }}</td>
              <td>{{ customer.leadType }}</td>
              <td>{{ customer.product }}</td>
              <td>{{ customer.plan }}</td>
              <td>{{ customer.activationDate | date:'shortDate' }}</td>
              <td>
                <strong [ngStyle]="{ color: customer.netPay >= 0 ? '#22c55e' : '#ef4444' }">
                  {{ customer.netPay | currency }}
                </strong>
              </td>
            </tr>
          </tbody>
        </nz-table>
      </nz-card>

      <div *ngIf="selectedCycleCustomers?.length" class="mobile-cards customer-cards section-card">
        <h3 class="mobile-section-title">
          Customer Performance
          <span class="customer-count">({{ selectedCycleCustomers.length }} customers)</span>
        </h3>
        <nz-spin [nzSpinning]="customerDetailsLoading">
          <cdk-virtual-scroll-viewport itemSize="95" class="customer-scroll-viewport">
            <nz-card class="customer-card" nzBordered="false"
              *cdkVirtualFor="let customer of selectedCycleCustomers; trackBy: trackByCustomerId">
              <div class="customer-header" (click)="toggleCustomerCardExpansion(customer.customerId)">
                <div class="customer-name">{{ customer.customerName }}</div>
                <div class="customer-header-right">
                  <div class="customer-net" [ngStyle]="{ color: customer.netPay >= 0 ? '#22c55e' : '#ef4444' }">
                    {{ customer.netPay | currency }}
                  </div>
                  <i nz-icon [nzType]="isCustomerCardExpanded(customer.customerId) ? 'up' : 'down'"
                    class="expand-icon"></i>
                </div>
              </div>
              <div class="customer-details" *ngIf="isCustomerCardExpanded(customer.customerId)">
                <nz-descriptions nzSize="small" [nzColumn]="1">
                  <nz-descriptions-item nzTitle="Total Sales">{{ customer.salesCount }}</nz-descriptions-item>
                  <nz-descriptions-item nzTitle="Base">{{ customer.totalCommissions | currency
                    }}</nz-descriptions-item>
                  <nz-descriptions-item nzTitle="Holdbacks">{{ customer.totalHoldbacks | currency
                    }}</nz-descriptions-item>
                  <nz-descriptions-item nzTitle="Adjustments">{{ customer.totalAdjustments | currency
                    }}</nz-descriptions-item>
                  <nz-descriptions-item nzTitle="Net Pay">{{ customer.netPay | currency
                    }}</nz-descriptions-item>
                </nz-descriptions>
              </div>
            </nz-card>
          </cdk-virtual-scroll-viewport>
        </nz-spin>
      </div>

      <nz-card nzTitle="Adjustments" *ngIf="upcoming?.length" class="desktop-table section-card table-card"
        nzBordered="false">
        <div class="table-wrap">
          <nz-table [nzData]="upcoming" nzSize="small" [nzScroll]="{ x: '720px' }">
            <thead>
              <tr>
                <th></th>
                <th>Date Created</th>
                <th>Pay Date</th>
                <th>Amount</th>
                <th>Note</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let u of upcoming">
                <td>
                  <button nz-button nz-popover nzPopoverContent="View details" nzType="primary" nzShape="circle"
                    (click)="loadAdjustmentModal(u)">
                    <span nz-icon nzType="eye" nzTheme="outline"></span>
                  </button>
                </td>
                <td>{{ u.date_created | date:'mediumDate' }}</td>
                <td>{{ formatPayDate(u.pay_date) }}</td>
                <td>{{ u.amount | currency}}</td>
                <td>{{ u.note | titlecase }}</td>
              </tr>
            </tbody>
          </nz-table>
        </div>
      </nz-card>
      <div class="mobile-adjustments" *ngIf="upcoming?.length">
        <h3 class="mobile-section-title">Adjustments</h3>
        <div class="adjustment-card" *ngFor="let u of upcoming; trackBy: trackByAdjustment">
          <div class="adjustment-card-header">
            <div class="adjustment-date">{{ formatPayDate(u.pay_date || u.payoutDate) }}</div>
            <div class="adjustment-amount" [ngStyle]="{ color: asNumber(u.amount) >= 0 ? '#22c55e' : '#ef4444' }">
              {{ u.amount | currency }}
            </div>
          </div>
          <div class="adjustment-details">
            <div class="adjustment-row">
              <span class="label">Created</span>
              <span>{{ u.date_created | date:'mediumDate' }}</span>
            </div>
            <div class="adjustment-row" *ngIf="u.note">
              <span class="label">Note</span>
              <span>{{ u.note }}</span>
            </div>
          </div>
          <button nz-button nzType="default" nzBlock (click)="loadAdjustmentModal(u)">
            <span nz-icon nzType="eye"></span>
            View Details
          </button>
        </div>
      </div>

    </div>
  </div>
</nz-spin>

<nz-modal class="customer-performance-modal" [(nzVisible)]="customerPerformanceModal" [nzTitle]="null" [nzWidth]="860"
  nzCentered (nzOnCancel)="handleCancel()" [nzFooter]="null">
  <ng-container *nzModalContent>
    <div class="customer-modal" *ngIf="selectedCustomerPerformance">
      <div class="customer-modal-header">
        <div class="customer-avatar">
          {{ (selectedCustomerPerformance?.customerName || 'C') | slice:0:1 | uppercase }}
        </div>
        <div class="customer-heading">
          <div class="customer-name">{{ selectedCustomerPerformance?.customerName || 'Customer' }}</div>
          <div class="customer-subtitle">
            <nz-tag *ngIf="selectedCustomerPerformance?.leadType" nzColor="blue">
              {{ selectedCustomerPerformance?.leadType }}
            </nz-tag>
            <nz-tag *ngIf="selectedCustomerPerformance?.product">
              {{ selectedCustomerPerformance?.product }}
            </nz-tag>
            <nz-tag *ngIf="selectedCustomerPerformance?.plan">
              {{ selectedCustomerPerformance?.plan }}
            </nz-tag>
            <span class="customer-date" *ngIf="selectedCustomerPerformance?.activationDate">
              Activated {{ selectedCustomerPerformance?.activationDate | date:'mediumDate' }}
            </span>
          </div>
        </div>
        <div class="customer-net-chip"
          [ngClass]="{ 'positive': selectedCustomerPerformance?.netPay >= 0, 'negative': selectedCustomerPerformance?.netPay < 0 }">
          <span>Net Pay</span>
          <strong>{{ selectedCustomerPerformance?.netPay | currency }}</strong>
        </div>
      </div>

      <div class="customer-meta">
        <div class="meta-item" *ngIf="selectedCustomerAddressLines.length">
          <div class="meta-label">Address</div>
          <div class="meta-value">{{ selectedCustomerAddressLines.join(' ') }}</div>
        </div>
        <div class="meta-item" *ngIf="selectedCustomerPerformance?.salesCount">
          <div class="meta-label">Total Sales</div>
          <div class="meta-value">{{ selectedCustomerPerformance?.salesCount }}</div>
        </div>
        <div class="meta-item" *ngIf="selectedCustomerPerformance?.activationDate">
          <div class="meta-label">Activation</div>
          <div class="meta-value">{{ selectedCustomerPerformance?.activationDate | date:'mediumDate' }}</div>
        </div>
      </div>

      <div class="metric-grid">
        <div class="metric-card">
          <div class="metric-label">Base</div>
          <div class="metric-value">{{ (selectedCustomerPerformance?.totalCommissions || 0) | currency }}</div>
        </div>
        <div class="metric-card">
          <div class="metric-label">Adjustments</div>
          <div class="metric-value">{{ (selectedCustomerPerformance?.totalAdjustments || 0) | currency }}</div>
        </div>
        <div class="metric-card">
          <div class="metric-label">Holdbacks</div>
          <div class="metric-value">{{ (selectedCustomerPerformance?.totalHoldbacks || 0) | currency }}</div>
        </div>
        <div class="metric-card">
          <div class="metric-label">Net Pay</div>
          <div class="metric-value emphasis"
            [ngStyle]="{ color: selectedCustomerPerformance?.netPay >= 0 ? '#22c55e' : '#ef4444' }">
            {{ (selectedCustomerPerformance?.netPay || 0) | currency }}
          </div>
        </div>
      </div>

      <div class="note-card" *ngIf="selectedCustomerPerformance?.note">
        <div class="note-label">
          <i nz-icon nzType="highlight" nzTheme="outline"></i>
          Performance Note
        </div>
        <p class="note-text">{{ selectedCustomerPerformance?.note }}</p>
      </div>
    </div>
  </ng-container>
</nz-modal>